import React, { Component } from 'react'
import { connect } from 'react-redux'
import { languageSwitchItem } from '../actions/locales'
import i18next from 'i18next'
import { createSession, sendInputData, sendSessionOption, sendKeyContainer, sendCertificate,
		 encryptData, getEncryptedData, deleteSession, sendTokenPath } from '../actions/api'
import { setBase64String, setCertificateInputFile, clearCertificateInputFile,
		 setInputFileForEncrypt, clearInputFileForEncrypt, setEncryptedData, clearEncryptedData } from '../actions/localStates'
import { bindActionCreators } from 'redux';

import EncryptOptionsContainer from './EncryptOptionsContainer'
import EncryptTextContainer from './EncryptTextContainer'

class EncryptContainer extends Component {

	constructor(props) {
    super(props);

	    this.state = {
			baseUrl: "https://local.cipher.kiev.ua:9090/api/v1/ticket/",
			uuid: null,
			isLoading: false,
			base64Data: null,
			downloadIsAvailable: true
		}
	}

	buildFileInputSelector(){
		const certInput = document.getElementById('certInputUpload');
		return certInput;
	}

	buildFileWithDSSelector(){
		const fileForEncrypt = document.getElementById('fileForEncryptUpload');
		return fileForEncrypt;
	}

	componentDidMount(){
    	this.certInput = this.buildFileInputSelector();
    	this.fileForEncryp = this.buildFileWithDSSelector();
	}

	handleCertInput(e) {
	    e.preventDefault();
	    this.certInput.value = null;
	    this.certInput.click()
	    document.activeElement.blur()
	}

	handleFileForEncryp(e) {
	    e.preventDefault();
	    this.fileForEncryp.value = null;
	    this.fileForEncryp.click()
	    document.activeElement.blur()
	}

	onChangeCertInput(e) {
		if (e.target.files[0] !== undefined && (e.target.files[0].size < 104857600)) {
			this.props.actions.setCertificateInputFile(e.target.files[0])
			this.props.actions.clearEncryptedData()
		}
	}

	onChangeFileForEncryp(e) {
		if (e.target.files[0] !== undefined && (e.target.files[0].size < 104857600)) {
			this.props.actions.setInputFileForEncrypt(e.target.files[0])
			this.props.actions.clearEncryptedData()
		} else {
			alert(i18next.t("maxFileSizeTitle": "maxFileSizeTitle"))
		}
	}

	cleanUpCertInput() {
		this.props.actions.clearCertificateInputFile()
		this.props.actions.clearEncryptedData()
	}

	cleanUpFileForEncryp() {
		this.props.actions.clearInputFileForEncrypt()
		this.props.actions.clearEncryptedData()
	}

	cleanUpForm() {
		this.cleanUpFileForEncryp()
		this.props.actions.clearEncryptedData()
	}

	getBlobData() {
		var _this = this
	    var saveBlob = (function () {
	        var a = document.createElement("a");
	        document.body.appendChild(a);
	        a.style.cssText = "display: none";
	        return function (blob, fileName) {
	        	if (navigator.appVersion.toString().indexOf('.NET') > 0) {
		           window.navigator.msSaveBlob(blob, fileName);
		        } else {
		            var url = window.URL.createObjectURL(blob);
		            a.href = url;
		            a.download = fileName;
		            a.click();
		            window.URL.revokeObjectURL(url);     
		        }
		        window.setTimeout(function () {
			    	_this.setState({downloadIsAvailable: true})
			    }, 1000) 
	        };
	    }());

	    this.setState({downloadIsAvailable: false})
	    saveBlob(this.props.defaultEncrypState.encData, this.props.defaultEncrypState.fileForEncryptName + ".p7e");
	}

	encrypt() {
		this.setState({isLoading: true})
		this.props.actions.createSession(this.props.connectionStatus.baseUrl)
        	.then((response) => {
				this.setState({uuid: response.ticketUuid})
				console.log(response);
			return this.props.actions.sendInputData(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.defaultEncrypState.fileForEncrypt)
	            .then(() => this.props.actions.sendSessionOption(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.defaultState))
	            .then(() => this.props.actions.setBase64String(this.props.defaultEncrypState.fileCertInput))
	            .then((response) => {
	            	this.setState({base64Data: response})
                    console.log(response);
                return this.props.actions.sendCertificate(this.props.connectionStatus.baseUrl, this.state.uuid, this.state.base64Data)
                	.then(() => this.props.actions.encryptData(this.props.connectionStatus.baseUrl, this.state.uuid))
		            .then(() => this.props.actions.getEncryptedData(this.props.connectionStatus.baseUrl, this.state.uuid))
		           	.then((response) => {
		           		if (response !== null) {
	            			this.props.actions.setEncryptedData(response)
	                    	console.log(response)
	                    	alert(i18next.t("enc:encryptionSuccess": "encryptionSuccess"))
	            		} else {
	            			alert(i18next.t("enc:encryptionError": "encryptionError"))
	            		}
	            		this.setState({isLoading: false})
	                })
		            .then(() => this.props.actions.deleteSession(this.props.connectionStatus.baseUrl, this.state.uuid))
                })
        })		
    }

	render() {
		const isEnabled = this.props.defaultEncrypState.fileCertInputSelected && this.props.defaultEncrypState.fileForEncryptSelected && !this.state.isLoading
		const downloadEnable = this.props.defaultEncrypState.encData && this.state.downloadIsAvailable
		return (
			<div>
            <div className="row" style={{paddingTop: "10px"}}>
            <EncryptOptionsContainer />
				<div className="col-8">
	                <div className="card" style={{"marginBottom": "10px"}}>
						<div className="card-header">
							{i18next.t("enc:recipientCertificate": "recipientCertificate")}
						</div>
	                  	<div className="card-body">
	                    	<label>{i18next.t("enc:recipientCertificateTitle": "recipientCertificateTitle")}</label>
	                        <div className="input-group mb-3">
								<input type="text" className="form-control" value={this.props.defaultEncrypState.certInputName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleCertInput.bind(this)} readOnly />
								
									{
										this.props.defaultEncrypState.fileCertInputSelected ? <div className="input-group-append">
									      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.handleCertInput.bind(this)}>{i18next.t("changeFile": "changeFile")}</button>
									      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.cleanUpCertInput.bind(this)}>{i18next.t("cleanup": "cleanup")}</button>
									    </div> : <div className="input-group-append">
									    	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.handleCertInput.bind(this)}>{i18next.t("chooseFile": "chooseFile")}</button>
									    </div>
									}
									
								
								<input id="certInputUpload" type="file" onChange={this.onChangeCertInput.bind(this)} style={{"display": "none"}} />
							</div>
	                    </div>
	                </div>
	                {
		                <div className="card" style={{"marginBottom": "10px"}}>
							<div className="card-header">
								{i18next.t("file": "file")}
							</div>
		                  	<div className="card-body">
		                    	<label>{i18next.t("enc:fileForEncryptTitle": "fileForEncryptTitle")}</label>
		                        <div className="input-group mb-3">
									<input type="text" className="form-control" value={this.props.defaultEncrypState.fileForEncryptName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileForEncryp.bind(this)} readOnly />
									{
										this.props.defaultEncrypState.fileForEncryptSelected ? <div className="input-group-append">
										      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.handleFileForEncryp.bind(this)}>{i18next.t("changeFile": "changeFile")}</button>
										      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.cleanUpFileForEncryp.bind(this)}>{i18next.t("cleanup": "cleanup")}</button>
										    </div> : <div className="input-group-append">
										    	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.handleFileForEncryp.bind(this)}>{i18next.t("chooseFile": "chooseFile")}</button>
										    </div>
									}
									<input id="fileForEncryptUpload" type="file" onChange={this.onChangeFileForEncryp.bind(this)} style={{"display": "none"}} />
								</div>
								<button className="btn btn-default" onClick={this.encrypt.bind(this)} disabled={!isEnabled}>{i18next.t("enc:performDataEncryption": "performDataEncryption")}
									{
		                                this.state.isLoading ? <span>&nbsp;<i className="fa fa-spinner fa-pulse"></i></span>
		                                : null
		                            }
								</button>
		                        <button className="btn btn-default" style={{marginLeft: "7px"}} disabled={!downloadEnable} onClick={this.getBlobData.bind(this)}>{i18next.t("enc:saveEncryptedData": "saveEncryptedData")}</button>
		                        <button className="btn btn-default" style={{marginLeft: "7px"}} onClick={this.cleanUpForm.bind(this)}>{i18next.t("cleanUpForm": "cleanUpForm")}</button>
		                    </div>
		                </div>
		            }
	                <EncryptTextContainer />
                </div>
            </div>
        </div>
		);
	}
}

function mapStateToProps(state) {
    return {
        locales: state.i18n,
        localesReducer: state.localesReducer,
        pkLocalState: state.privateKeyReducer,
        defaultState: state.encryptOptionsReducer,
        defaultEncrypState: state.encryptReducer,
        connectionStatus: state.connectionStatusReucer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
	    languageSwitchItem,
	    createSession,
	    sendInputData,
	    sendSessionOption,
	    sendKeyContainer,
	    setBase64String,
	    sendCertificate,
	    encryptData,
	    getEncryptedData,
	    deleteSession,
	    setCertificateInputFile,
	    clearCertificateInputFile,
	    setInputFileForEncrypt,
	    clearInputFileForEncrypt,
	    setEncryptedData,
	    clearEncryptedData,
	    sendTokenPath
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(EncryptContainer);


// WEBPACK FOOTER //
// ./src/containers/EncryptContainer.js